import React, { useState, useEffect } from 'react';
import { db } from "firebase/fbConfig.js";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";

const AddNewGroupForm = props => {
    const [name, setName] = useState('');
    const [description, setDescription] = useState('');

    const createGroup = () => {
        db.collection('haney-groups').add({
            name,
            description
        })
            .then(res => {
                console.log(res);
                window.location.reload();
            })
    }

    return (
        <GridContainer>
            <GridItem xs={12}>
                <CustomInput
                    labelText="Name"
                    id="name"
                    formControlProps={{
                        fullWidth: true
                    }}
                    inputProps={{
                        type: "text",
                        onChange: (e) => setName(e.target.value),
                        value: name
                    }}
                />
            </GridItem>
            <GridItem xs={12}>
                <CustomInput
                    labelText="Description"
                    id="description"
                    formControlProps={{
                        fullWidth: true
                    }}
                    inputProps={{
                        type: "text",
                        onChange: (e) => setDescription(e.target.value),
                        value: description
                    }}
                />
            </GridItem>
            <GridItem>
                <Button 
                    color='primary'
                    onClick={createGroup}
                >
                    SAVE
                </Button>
            </GridItem>
        </GridContainer>
    );
}

export default AddNewGroupForm;


// WEBPACK FOOTER //
// ./src/components/Forms/AddNewGroupForm.jsx